import { SURVEY_EXPORT_STATUS } from "./constants";

export function resolveExportJobId(payload) {
    if (!payload || typeof payload !== "object") {
        return null;
    }
    if (payload.id != null) {
        return payload.id;
    }
    if (payload.data && payload.data.id != null) {
        return payload.data.id;
    }
    return null;
}

export function isCsvContentType(contentType) {
    return String(contentType || "").includes("text/csv");
}

export function nextExportPollAction(status, attempt, maxAttempts = 10) {
    if (status === SURVEY_EXPORT_STATUS.DONE) {
        return "ready";
    }
    if (status === SURVEY_EXPORT_STATUS.PENDING && attempt < maxAttempts) {
        return "poll";
    }
    return "error";
}
